<template>
  <div
    class="custom-tab-bd"
    :class="{ 'fix-border': fixBorder }"
  >
    <ul class="ub">
      <li
        @click="onTab(item)"
        :class="{ current: val == item.value }"
        v-for="(item, index) in list"
        :key="index"
        :title="valueKey!=='name'?$t(item.code):item.name"
      >
        {{valueKey!=='name'?$t(item.code):item.name }}
      </li>
      <li class="ub-f1"></li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    valueKey: {
      type: String,
      default() {
        return 'name';
      }
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    // 组件默认tab item的border-top为空，当fixBorder为true时，会添加缺省的border
    fixBorder: Boolean,
  },
  data() {
    return {
      val: this.value,
    };
  },
  watch: {
    value: function (val) {
      this.val = val;
    },
  },
  methods: {
    onTab: function (item) {
      this.$emit('changeBefore', this.val, item.value);
      this.val = item.value;
      this.$emit('input', item.value);
      this.$emit('change', item.value);
    },
  },
};
</script>
<style lang="scss">
@import '@/style/mixin.scss';

.custom-tab-bd {
  ul li {
    cursor: pointer;
    line-height: 38px;
    height: 40px;
    color: #495057;
    font-size: 12px;
    padding: 0 20px;
    border-top: 2px solid #ffffff;
    border-right: 1px solid #eef2f8;
    border-bottom: 1px solid #eef2f8;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:last-child {
      border-right: none;
    }
    &.current {
      @include color_main();
      @include border_top_color_main();
      border-top-width: 2px;
      border-top-style: solid;
      font-weight: bold;
      position: relative;
      z-index: 1;
      border-bottom: none;
    }
  }

  &.fix-border {
    ul li {
      border-top: 1px solid #eef2f8;
      line-height: 40px;

      &:nth-child(1) {
        border-left: 1px solid #eef2f8;
      }
      &.current {
        border-top: 2px solid #0d9ae0;
        line-height: 39px;
      }
    }
    .ub-f1 {
      border-top: none;
    }
  }
}
</style>
